import styled from 'styled-components';
import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { OutputRow, TableIcon, BoldLabel, Colors } from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";
import SubtotalColumns from "../../experiences/cost-summary/subtotal-cols";
import { displayValue } from "../../helper";
import { calculateSubCostNoFlightsPerAttendee, calculateCostPerAttendee, calculateInternalCostA, calculateInternalCostB } from "../../experiences/cost-summary/cost-helper";
import { GetDB } from "../../../../utils/database/firebase-budget-tool";
import { listenToDocument } from "../../../../utils/firestore-functions";

const RebelFinalCostRow = ({guideData, expData, clientCurrency, currencyConversionRatio, villaId}) => {

    const budgetDB = GetDB();
    const [villaData, setVillaData] = useState(null);

    useEffect(() => {
        if (villaId && villaId !== '0' && villaId !== '') {
            const unsubscribe = listenToDocument(budgetDB, "rebelVillas", villaId, setVillaData);
            return unsubscribe;
        }
    }, [villaId]);

    useEffect(() => {
        console.log('Villa notes:', villaData?.notes);
        console.log('Experience notes:', expData?.notes);
    }, [villaData, expData]);

    // Calculate margin with proper attendee multiplication
    const calculateMarginCost = () => {
        if (guideData.marginPercent === undefined || guideData.marginPercent.value === true) {
            // Percentage-based margin (existing calculation)
            return calculateInternalCostB(guideData, expData, clientCurrency, currencyConversionRatio);
        } else {
            // Dollar-based margin - multiply by number of attendees
            return parseFloat(guideData.margin.value) * guideData.attendees.value;
        }
    };

    const marginCost = calculateMarginCost();
    const overheadCost = calculateInternalCostA(guideData, expData, clientCurrency, currencyConversionRatio);

    return (
        <React.Fragment>
            <SeparatorDiv/>
            <OutputRow>
            <Col style={{display: "flex", justifyContent: "flex-end"}}>
                    <RebelText style={{marginBottom: "16px"}}><b>Subtotal ({guideData.currency.value})</b></RebelText>
                </Col>
                <Col lg="1"/>
                <Col lg="2">
                    <RebelText style={{marginBottom: "16px"}}>{guideData.currency.value.slice(3)}{displayValue(calculateCostPerAttendee(guideData,expData) * guideData.attendees.value)}</RebelText>
                </Col>
            </OutputRow>
            <OutputRow>
                <Col style={{display: "flex", justifyContent: "flex-end"}}>
                    {(guideData.overheadPercent === undefined || guideData.overheadPercent.value === true) ?
                        <RebelText style={{marginBottom: "16px"}}>Administrative & Management Fee ({guideData.overhead.value}%)</RebelText> :
                        <RebelText style={{marginBottom: "16px"}}>{(guideData.overheadPercent === undefined || guideData.margin.value === "0") ? "Administrative & Management Fee" : "Administrative & Management Fee"}</RebelText>
                    }
                </Col>
                <Col lg="1"/>
                <Col lg="2">
                    <RebelText style={{marginBottom: "16px"}}>{guideData.currency.value.slice(3)}{displayValue(overheadCost)}</RebelText>
                </Col>
            </OutputRow>
            {guideData.margin.value !== "0" && <OutputRow>
                <Col style={{display: "flex", justifyContent: "flex-end"}}>
                    {(guideData.marginPercent === undefined || guideData.marginPercent.value === true) ?
                        <RebelText style={{marginBottom: "16px"}}>Planning Fee ({guideData.margin.value}%) </RebelText> :
                        <RebelText style={{marginBottom: "16px"}}>Planning Fee ({guideData.attendees.value} x {guideData.currency.value.slice(3)}{guideData.margin.value})</RebelText>
                    }
                </Col>
                <Col lg="1"/>
                <Col lg="2">
                    <RebelText style={{marginBottom: "16px"}}>{guideData.currency.value.slice(3)}{displayValue(marginCost)}</RebelText>
                </Col>
            </OutputRow>}
            <OutputRow>
                <Col style={{display: "flex", justifyContent: "flex-end"}}>
                    <RebelBoldLabel>Total Program Cost ({guideData.currency.value})</RebelBoldLabel>
                </Col>
                <Col lg="1"/>
                <Col lg="2">
                    <RebelBoldLabel>{guideData.currency.value.slice(3)}{displayValue(overheadCost + marginCost + calculateCostPerAttendee(guideData,expData) * guideData.attendees.value)}</RebelBoldLabel>
                </Col>
            </OutputRow>
            <RebelNoBorderRow>
                <Col style={{display: "flex", justifyContent: "flex-end"}}>
                    <RebelHighlightedText>Total Cost Per Attendee ({guideData.currency.value})</RebelHighlightedText>
                </Col>
                <Col lg="1"/>
                <Col lg="2">
                    <RebelHighlightedText>{guideData.currency.value.slice(3)}{displayValue((overheadCost + marginCost + calculateCostPerAttendee(guideData,expData) * guideData.attendees.value) / guideData.attendees.value)}</RebelHighlightedText>
                </Col>
            </RebelNoBorderRow>
            {(villaData?.notes || expData?.notes) && (
                <RebelNoBorderRow>
                    <Col>
                        {villaData?.notes && (
                            <NotesContainer>
                                <NotesTitle>Property Notes</NotesTitle>
                                <NotesContent>{villaData.notes}</NotesContent>
                            </NotesContainer>
                        )}
                        {expData?.notes && (
                            <NotesContainer>
                                <NotesTitle>Experience Notes</NotesTitle>
                                <NotesContent>{expData.notes}</NotesContent>
                            </NotesContainer>
                        )}
                    </Col>
                </RebelNoBorderRow>
            )}
        </React.Fragment>
    )
}

export default RebelFinalCostRow;

const SeparatorDiv = styled.div`
    background-color: ${RebelColors.gold};
    width: 100%;
    height: 5px;
    border-radius: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
`;

const RebelText = styled.p`
    color: ${RebelColors.primary};
`;

const RebelBoldLabel = styled(BoldLabel)`
    color: ${RebelColors.gold};
`;

const RebelHighlightedText = styled.p`
    color: ${RebelColors.gold};
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 16px;
`;

const RebelNoBorderRow = styled(OutputRow)`
    && {
        border-bottom: none !important;
    }
`;

const HighlightedBoxContainer = styled.div`
    position: absolute;
    left: 15px;
    right: 15px;
    top: 0;
    border: 2px solid ${RebelColors.gold};
    border-radius: 6px;
    padding: 8px 0;
    display: flex;
    align-items: center;
    pointer-events: none;

    > * {
        pointer-events: auto;
    }
`;

const NotesContainer = styled.div`
    background-color: ${RebelColors.surfaceLight};
    border: 1px solid ${RebelColors.border};
    border-radius: 8px;
    padding: 16px;
    margin: 16px 0;
`;

const NotesTitle = styled.h4`
    color: ${RebelColors.gold};
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
`;

const NotesContent = styled.p`
    color: ${RebelColors.primary};
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
    white-space: pre-wrap;
`;
